// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{ label:'业务日期：',xs:24,sm:24,md:12,lg:24,xl:24,type:'date',modelValue:'busDate',disabled:true},
	{ label:'库房名称：',xs:24,sm:24,md:12,lg:8,xl:8,type:'select',modelValue:'shedId',op:'selectOption'},
	
	{ label:'供货单位：',xs:24,sm:8,md:12,lg:8,xl:8,type:'select',modelValue:'supplyCandidateId',op:'gysOption'},
	{ label:'供货单号：',xs:24,sm:16,md:12,lg:8,xl:8,type:'input',modelValue:'supplyCode',placeholder:''},
	
	{ label:'发票编号：',xs:24,sm:12,md:6,lg:8,xl:8,type:'input',modelValue:'purcInvoCodg',placeholder:'',placeholder:'',},
	{ label:'开票日期：',xs:24,sm:12,md:6,lg:8,xl:8,type:'date',modelValue:'invoDate',placeholder:''},
	
	{ label:'出库方式：',xs:12,sm:12,md:6,lg:6,xl:8,type:'select',modelValue:'retnTypeId',op:'retnTypeOptions'},
	
	{ label:'备注：',xs:24,sm:24,md:24,lg:24,xl:24,type:'textarea',modelValue:'remark',placeholder:'',},
	
	// { label:'药品名称：',xs:12,sm:8,md:8,lg:8,xl:6,type:'select',modelValue:'drugName',im:false,placeholder:'',op:'nameOption'},
	// { label:'规格描述：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'gg',im:false,placeholder:'',op:'selectOption'},
	// { label:'采购类别：',xs:12,sm:8,md:8,lg:8,xl:6,type:'select',modelValue:'cglb',placeholder:'',op:'cgOption',},
	// { label:'生产厂家：',xs:12,sm:8,md:8,lg:8,xl:6,type:'select',modelValue:'cj',placeholder:''},
	
	// { label:'加成方式：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'jc',placeholder:''},
	// { label:'加成信息：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'num',placeholder:''},
	// { label:'产地：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'cd',placeholder:''},
	// { label:'生产批号：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'ph',placeholder:''},
	
	// { label:'批准文号：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'wh',placeholder:'',},
	// { label:'成本单价：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'cbdj',placeholder:''},
	// { label:'小单位成本单价：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'xdwcbdj',placeholder:'',},
	// { label:'零售单价：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'lsdj',placeholder:''},
	
	// { label:'小单位零售单价：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'xdwlsdj',placeholder:'',},
	// { label:'数量（盒）：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'num',placeholder:''},
	// { label:'数量（支）：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'numZ',placeholder:'',},
	// { label:'成本金额：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'cbje',placeholder:'',},
	
	// { label:'零售金额：',xs:6,sm:6,md:6,lg:6,xl:6,type:'input',modelValue:'lsje',placeholder:'',},
	// { label:'网上采购：',xs:6,sm:6,md:6,lg:6,xl:6,type:'select',modelValue:'onlineValue',placeholder:'',op:'onlineOptions'},
	// { label:'网采编码：',xs:6,sm:6,md:6,lg:6,xl:12,type:'input',modelValue:'educationalBackground',placeholder:'',},
	
	// { label:'生产日期：',xs:6,sm:6,md:6,lg:6,xl:12,type:'date',modelValue:'scrq',placeholder:'',},
	// { label:'有效日期：',xs:6,sm:6,md:6,lg:6,xl:12,type:'date',modelValue:'yxrq',placeholder:''},
	
	
	// { label:'加入',xs:24,sm:24,md:24,lg:24,xl:24,type:'btn',modelValue:'educationalBackground',placeholder:'',},
]

